import { useCallback } from 'react';
import { ModalContainer } from 'src/components/ModalContainer';
import { useGlobalStore } from 'src/store';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { AddClientStep, type SavedClient } from './add-client-step';

export const AddClientModal = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { closeModal } = useModalMethods(Modals.AddClientModal);
  const { isOpened, modalProps } = useModalState(Modals.AddClientModal);

  const { client, address, participant, conversation, onSuccessSubmit } = modalProps ?? {};

  const partnerId =
    modalProps?.partnerId ??
    conversation?.partner?.partnerId ??
    client?.partner?.id ??
    client?.partnerId ??
    address?.partner?.id ??
    address?.partnerId ??
    selectedPartnerId;

  const handleSaved = useCallback(
    (saved: SavedClient) => {
      closeModal();
      onSuccessSubmit?.(saved);
    },
    [closeModal, onSuccessSubmit],
  );

  return (
    <ModalContainer open={isOpened} onClose={closeModal}>
      <AddClientStep
        partnerId={partnerId}
        client={client || null}
        address={address || null}
        participant={participant || null}
        onSaved={handleSaved}
      />
    </ModalContainer>
  );
};
